import { PlatformAdminZone } from '@skylabs-digital/react-identity-access';
import { Outlet } from 'react-router-dom';

/**
 * La guarda de las rutas de adentro: el contexto `(platform, admin)`.
 *
 * ## Que cambio con RIA 5, y por que este archivo encogio
 *
 * Hasta RIA 4 la decision la tomaba `PlatformAdminOnly`, un componente LOCAL
 * que leia `context` a traves de un cast a `unknown`. Existia por una razon
 * concreta y temporal: el `Plane` de RIA 4 era el enum viejo de un solo eje
 * (`SYSTEM | TENANT_ADMIN | TENANT_USER`), su `AuthContextInfo` no tenia
 * `scope`, y su unica API de autorizacion —`Protected minPlane="…"`— no tenia
 * donde poner el segundo eje. El propio archivo decia que se borraba en cuanto
 * saliera v5. Salio, y se borro.
 *
 * RIA 5 modela el requisito como CONTEXTO REQUERIDO: pertenencia al par
 * `(scope, plane)`, no un minimo sobre un orden. `PlatformAdminZone` es el
 * preset `platformAdmin` —`auth: 'required'` mas `requiredContext:
 * { scope: 'platform', plane: 'admin' }`— y es exactamente lo que esta
 * superficie exige.
 *
 * ## Por que la decision vuelve a la libreria
 *
 * Porque una guarda copiada en cada consumidor es una guarda que se desvia en
 * cada consumidor. Ademas la version de RIA falla cerrado por construccion:
 * `parseAuthContext` es el UNICO camino desde el JSON del cable hasta
 * `AuthContextInfo`, y rechaza cualquier combinacion que el modelo no admita
 * —un contexto de la forma vieja sin `scope`, o la celda prohibida
 * `(platform, use)`— dejando `context` en `null`. Un `null` no pertenece a
 * ningun conjunto, asi que no entra nadie.
 *
 * `LoginPage` evalua EL MISMO preset por nombre (`preset: 'platformAdmin'`).
 * Que sea el mismo nombre y no dos predicados equivalentes es lo que hace
 * imposible el rebote entre `/login` y `/`.
 *
 * ## Que NO volvio
 *
 * `requiredRoles`. En una superficie de plataforma no hay dos niveles que
 * distinguir: todo el que entra es un actor de plataforma. Cuando haga falta
 * separar SUPERADMIN de SUPPORT/AUDITOR eso sale de `context.role` y es otra
 * guarda — hay una bead abierta en idachu (`idachu-ji8`) para el backoffice en
 * solo lectura.
 */
export function ProtectedRoute() {
  return (
    <PlatformAdminZone
      redirectTo="/login"
      loadingFallback={() => (
        <div className="flex h-screen items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
        </div>
      )}
    >
      <Outlet />
    </PlatformAdminZone>
  );
}
